import * as z from "zod";
import { Icon } from "./Icon";
import { TranslatedText } from "./TranslatedText";
export const TestCaseStepperContent = z.object({
    type: z.literal("test_case_stepper_content"),
    value: z.object({
        mark: Icon,
        header: TranslatedText,
        testCaseResult: z.object({
            input: z.string(),
            output: z.string(),
            expected: z.string(),
        }),
    }),
});
